// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t7Xgv","textWrapper":"styles_textWrapper__WPFac","link":"styles_link__DLhRX"};